import Timeline from "../timeline/timeline";
import { NavLink } from "react-router-dom";

const Plan = () => {

    return (
      <>
        <article className="flex w-0 flex-1 flex-col gap-6 py-10">
          <div className="prose">
            <h1>Мы планируем</h1>
            <Timeline/>
          </div>
          <div className="mt-4 flex flex-row flex-wrap gap-4 border-t py-12">
            <NavLink className="flex flex-row items-center gap-2 text-muted-foreground transition-colors hover:text-foreground ms-auto" to="/contacts">
              <p className="text-end font-medium text-foreground">
                Контакты
              </p>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-chevron-right size-5 shrink-0 rtl:rotate-180">
                <path d="m9 18 6-6-6-6">
                </path>
              </svg>
            </NavLink>
          </div>
        </article>
      </>
    );
  };
  
  export default Plan;